"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import styles from "./navbar.module.css";

import LanguageSwitcher from "../LanguageSwitcher";

import { useTranslations } from "next-intl";

export default function Navbar({ locale }) {
    const t = useTranslations('Navbar');
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const closeMenu = () => setMenuOpen(false);

    // Prevent body scroll when menu is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    return (
        <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ""} ${menuOpen ? styles.menuIsOpen : ""}`}>
            <div className={`container ${styles.container}`}>
                <Link href={`/${locale}`} className={styles.logo} onClick={closeMenu}>
                    {t('brand')}
                </Link>

                {/* Desktop Links */}
                <div className={styles.links}>
                    <LanguageSwitcher scrolled={scrolled} />
                    <Link href={`/${locale}/#about`} className={styles.link}>{t('about')}</Link>
                    <Link href={`/${locale}/#services`} className={styles.link}>{t('services')}</Link>
                    <Link href={`/${locale}/#projects`} className={styles.link}>{t('projects')}</Link>
                    <Link href={`/${locale}/#articles`} className={styles.link}>{t('articles')}</Link>
                    <Link href={`/${locale}/#contact`} className={styles.cta}>
                        {t('contact')}
                    </Link>
                </div>

                {/* Mobile Right Side: Language Switcher + Hamburger */}
                <div className={styles.mobileRight}>
                    {/* Language switcher always visible on mobile, outside the dropdown */}
                    <div className={styles.mobileLangBtn}>
                        <LanguageSwitcher scrolled={menuOpen ? true : scrolled} />
                    </div>

                    {/* Hamburger Button */}
                    <button
                        className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ""} ${scrolled ? styles.hamburgerScrolled : ""}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label={menuOpen ? "Close menu" : "Open menu"}
                        aria-expanded={menuOpen}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>

            {/* Mobile Menu Drawer */}
            <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ""}`}>
                <div className={styles.mobileLinks}>
                    <Link href={`/${locale}/#about`} className={styles.mobileLink} onClick={closeMenu}>{t('about')}</Link>
                    <Link href={`/${locale}/#services`} className={styles.mobileLink} onClick={closeMenu}>{t('services')}</Link>
                    <Link href={`/${locale}/#projects`} className={styles.mobileLink} onClick={closeMenu}>{t('projects')}</Link>
                    <Link href={`/${locale}/#articles`} className={styles.mobileLink} onClick={closeMenu}>{t('articles')}</Link>
                    <Link href={`/${locale}/#contact`} className={styles.mobileCta} onClick={closeMenu}>
                        {t('contact')}
                    </Link>
                </div>
            </div>
        </nav>
    );
}
